import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); await checkAuth(); setTimeout(() => navigate("/impostazioni?s=plans"), 2500); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch { /* retry */ }
      if (++tries < 10) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
  }, [params, checkAuth, navigate]);
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4" data-testid="payment-success-page">
      <div className="athanor-card max-w-md p-8 text-center">
        {state === "checking" && <><Loader2 className="mx-auto mb-4 h-8 w-8 animate-spin text-[#C5A059]" /><h1 className="text-xl font-semibold text-slate-100">Confermo il pagamento…</h1><p className="mt-2 text-sm text-slate-400">Un attimo, sto verificando con Stripe.</p></>}
        {state === "paid" && <><CheckCircle2 className="mx-auto mb-4 h-10 w-10 text-emerald-400" /><h1 className="text-xl font-semibold text-slate-100" data-testid="payment-paid">Pagamento riuscito</h1><p className="mt-2 text-sm text-slate-400">Il tuo piano è attivo. La fattura arriva via email da Stripe. Ti porto alle impostazioni…</p></>}
        {(state === "error" || state === "timeout") && <><XCircle className="mx-auto mb-4 h-10 w-10 text-amber-400" /><h1 className="text-xl font-semibold text-slate-100">Non riesco a confermare</h1><p className="mt-2 text-sm text-slate-400">Se hai pagato, l'attivazione arriverà a breve: controlla Impostazioni → Piano tra qualche minuto.</p><Link to="/impostazioni?s=plans" className="btn btn-secondary mt-4 inline-flex">Vai al piano</Link></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4" data-testid="payment-cancel-page">
      <div className="athanor-card max-w-md p-8 text-center">
        <h1 className="text-xl font-semibold text-slate-100">Pagamento annullato</h1>
        <p className="mt-2 text-sm text-slate-400">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
        <Link to="/impostazioni?s=plans" className="btn btn-secondary mt-4 inline-flex" data-testid="payment-cancel-back">Torna al piano</Link>
      </div>
    </div>
  );
}
